import { CARD_TOPBAR_HEIGHT } from "components/Dashboard/CardWithControls/cardWithControlsUtils";
import styled, { css } from "styled-components/macro";

import { untaggedColor } from "../../../../constants/colors";
import {
  BREAKPOINT_TABLET,
  BREAKPOINT_DESKTOP,
  NAV_HEIGHT_PX,
  BREAKPOINT_MOBILE,
} from "../../../../constants/constants";
import { PNL_COLORS_CSS } from "./PNL_COLORS_CSS";
import { animated } from "@react-spring/web";
import { BREAKPOINT_DESKTOP_XL } from "components/MeritTier0Page/utils/tier0-utils";

export const IGNORE_BREAKPOINT_MIN_WIDTH = 999999;
export const IGNORE_BREAKPOINT_MAX_WIDTH = 0;

export const DetailsPlaceholder = styled.div`
  width: 50%;
  height: 150vh;
`;

export const TargetSoFarStyles = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  .targetSoFarAmount {
    text-align: left;
    margin-left: 0.5ch;
    width: fit-content;
  }
  .targetPerTimeAmount {
    font-size: 0.7em;
  }

  @media print {
    font-size: 16px !important;
  }
`;

const getMoveAndShrinkSkuNameCSS = (width: number) =>
  `max-width: ${widthPxFromPercent(width, 33)}px;
font-size: ${Math.max(18, widthPxFromPercent(width, 3.1))}px;
word-break: break-all;
@media (max-width: ${BREAKPOINT_MOBILE}px){
  margin-top: -8px;
}
`;
export function widthPxFromPercent(width: number | undefined, percent: number) {
  return ((width ?? 0) * percent) / 100;
}
function heightPxFromPercent(height: number | undefined, percent: number) {
  return ((height ?? 0) * percent) / 100;
}

export const MINI_MODE_HEIGHT = 148;
// tslint:disable-next-line: no-big-function
const HubletViewStyles = styled.div<{
  $skuCodeDisplayLength: number;
  $minOfWidthOrHeight: number;
  $isGridLayout: boolean;
  $isMiniMode: boolean;
  $width?: number;
  $height?: number;
  $ckey: string;
}>`
  display: flex;
  &.hidden {
    display: none;
  }
  overflow: visible;
  .background {
    overflow: hidden;
  }
  flex-direction: column;
  @media (min-width: ${BREAKPOINT_TABLET}px) {
    padding-top: ${CARD_TOPBAR_HEIGHT}px;
  }
  padding-bottom: 20px;
  box-sizing: border-box;

  max-height: calc(100vh - ${NAV_HEIGHT_PX}px);
  justify-content: space-around;
  min-width: 0;

  position: relative;

  .outOfFocus {
    opacity: 0.3;
  }

  .details-call-and-status-container {
    width: 100%;
    height: 30%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    position: relative;
  }
  &.internetExplorer {
    .details-call-and-status-container {
      justify-content: center;
    }
  }

  .details-top-row {
    z-index: 0;
    display: flex;
    justify-content: space-between;
    .top-row-item {
      display: flex;
      height: ${props => widthPxFromPercent(props.$width, 2)}px;
      align-items: start;
      justify-content: center;
    }
    .sku-indicator {
      justify-content: start;
      padding-left: ${props => widthPxFromPercent(props.$width, 2.64)}px;
      min-width: ${props => widthPxFromPercent(props.$width, 34)}px;
      max-width: ${props => widthPxFromPercent(props.$width, 34)}px;
    }
    .sku-indicator-sku-display {
      margin-top: 0.5em;
      font-size: 0.6em;
      /* TECHDEBT: temporary until we add a "metric target" field to midgard & HubletView */
      ${props =>
        ["naturesway", "natureswaytwo"].includes(props.$ckey)
          ? "font-size: 0.9em; white-space: nowrap;"
          : ""}
    }
    .workers-indicator {
      min-width: ${props => widthPxFromPercent(props.$width, 10)}px;
    }
    .tag-indicator {
      justify-content: flex-end;
      margin-right: 1.6vw;
      min-width: ${props => widthPxFromPercent(props.$width, 24)}px;
    }
  }
  .top-row-label {
    opacity: 0.7;
    max-width: ${props => widthPxFromPercent(props.$width, 6)}px;
    font-size: ${props => widthPxFromPercent(props.$width, 1.85)}px;
  }
  .top-row-value {
    max-width: ${props => widthPxFromPercent(props.$width, 35)}px;
    &.tag-status {
      max-width: ${props => widthPxFromPercent(props.$width, 45)}px;
      word-break: break-all;
    }
    font-size: ${props =>
      Math.max(18, widthPxFromPercent(props.$width, 3.5))}px;
    display: flex;
    flex-direction: column;
    justify-content: right;
    vertical-align: bottom;
    padding-left: ${props => widthPxFromPercent(props.$width, 0.8)}px;
  }
  .top-row-icon {
    margin-top: ${props => widthPxFromPercent(props.$width, -0.05)}px;
    svg {
      height: ${props => widthPxFromPercent(props.$width, 3.54)}px;
      width: ${props => widthPxFromPercent(props.$width, 3.54)}px;
      opacity: 0.5;
      stroke: none;
    }
  }
  .callout {
    font-weight: bold;
  }
  .bottomRowItem3 {
    .bottom {
      font-size: 0.7em;
      margin-top: 0.5em;
    }
  }
  .long-number {
    font-size: 0.7em;
  }
  .btn-more {
    position: absolute;
    top: 0;
    right: 0;
    padding: ${props => widthPxFromPercent(props.$width, 0.2)}px;
    svg {
      width: ${props => widthPxFromPercent(props.$width, 5.28)}px;
      height: ${props => widthPxFromPercent(props.$width, 5.28)}px;
    }
  }
  .details-call-icon {
    width: ${props => heightPxFromPercent(props.$height, 21.14)}px;
    position: absolute;
    left: calc(50% - ${props => heightPxFromPercent(props.$height, 40)}px);
  }
  .bottom-row {
    z-index: 0;
    display: flex;
  }

  @media print {
    width: 100%;
    height: 250px !important;
    .workers-indicator {
      margin-right: -200px;
    }
  }

  /* tablet breakpoint: details view on top, charts below  */
  @media (min-width: ${props =>
      props.$isGridLayout
        ? IGNORE_BREAKPOINT_MIN_WIDTH // for custom layout, ignore this breakpoint
        : BREAKPOINT_TABLET}px) and (max-width: ${BREAKPOINT_DESKTOP}px) {
    width: ${BREAKPOINT_TABLET}px;
    /* account for 1/2 scrollbar width due to overflow: overlay */
    @supports (overflow: overlay) {
      transform: translateX(-8px);
    }
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    margin: auto;
    .details-call-and-status-container {
      margin: 35px 0 0 0;
      width: 100%;
      height: 32%;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
      position: relative;
    }
    .details-top-row {
      .top-row-item {
        height: 15px;
      }
      .workers-indicator {
        min-width: 92px;
      }
      .tag-indicator {
        min-width: 0;
      }
      .tag-status {
        width: 180px;
      }
    }
    .top-row-value {
      padding-left: 16px;
      font-size: 27px;
    }
    .top-row-icon {
      margin-top: -1.6px;
      svg {
        height: 28px;
        width: 28px;
      }
    }
    .btn-more {
      padding: 2px;
      svg {
        width: 41.7px;
        height: 41.7px;
      }
    }
    .top-row-label {
      font-size: 14px;
    }
    .sku-indicator {
      padding-left: 20px;
    }
    .details-call-icon {
      width: 160px;
      left: calc(20% - 80px);
    }
  }

  /* desktop breakpoint: details view left, charts right */

  @media (min-width: ${BREAKPOINT_DESKTOP}px) {
    margin: 0;
    min-width: 0;
    width: 100%;
    justify-content: space-around;
    margin-top: ${NAV_HEIGHT_PX}px;
  }
  @media (min-width: ${BREAKPOINT_DESKTOP_XL}px) {
    .details-top-row {
      transform: translateY(-82px);
    }
    .details-call-and-status-container {
      transform: translateY(-45px);
    }
    .bottom-row {
      transform: translateY(-82px);
    }
  }
  /* prevent long sku names overlapping with center metric */
  .top-row-value.sku-indicator-content {
    ${props =>
      props.$skuCodeDisplayLength > 45
        ? getMoveAndShrinkSkuNameCSS(props.$width ?? 0)
        : ""}
  }

  .background {
    width: 100%;
    height: 100%;
    top: 0;
    position: absolute;
    z-index: 0;
    visibility: hidden;
  }

  @media print {
    .background {
      display: none !important;
      background-color: white !important;
    }
    &.details-process {
      background-color: white !important;
    }
    * {
      color: black !important;
    }
  }

  ${PNL_COLORS_CSS}
  &.negative {
    .background {
      background-color: ${untaggedColor};
    }
  }

  ${props =>
    props.$isGridLayout
      ? css`
          & {
            height: 100%;
            margin: 0;
            overflow: hidden;
          }
        `
      : ""}
  transition: border-radius 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  border-bottom-right-radius: 0px;
  ${props =>
    props.$isMiniMode
      ? css`
          background-color: transparent !important;
          .background {
            visibility: visible;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
          }
          & {
            margin-bottom: 10px;
          }
          @media (min-width: ${BREAKPOINT_DESKTOP}px) {
            .background {
              border-bottom-right-radius: 10px;
            }
          }
        `
      : ""}
`;
export const AnimatedHubletViewStyles = animated(HubletViewStyles);

const BottomRowItemStyles = styled.div<{
  $isGridLayout: boolean;
  $isMiniMode: boolean;
  $width: number;
}>`
  width: 100%;
  text-align: center;
  .row-1 {
    font-size: ${props => Math.max(14, widthPxFromPercent(props.$width, 3))}px;
    height: ${props => Math.max(14, widthPxFromPercent(props.$width, 3))}px;
  }
  .row-2 {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${props => widthPxFromPercent(props.$width, 14)}px;
    height: ${props => widthPxFromPercent(props.$width, 16)}px;
    padding: ${props => widthPxFromPercent(props.$width, 0.3)}px 0;
  }
  .row-3 {
    height: ${props => widthPxFromPercent(props.$width, 3)}px;
    font-size: ${props =>
      widthPxFromPercent(props.$width, props.$isGridLayout ? 4.5 : 3)}px;
  }
  .targetRateContent {
    position: relative;
    .teamSizeMultiplierIndicator {
      position: absolute;
      top: -1em;
      font-size: 0.7em;
      white-space: nowrap;
      display: flex;
      justify-content: center;
      left: 0;
      right: 0;
    }
  }
  @media (min-width: ${props =>
      props.$isGridLayout
        ? IGNORE_BREAKPOINT_MIN_WIDTH // for custom layout, ignore this breakpoint
        : BREAKPOINT_TABLET}px) and (max-width: ${props =>
      props.$isGridLayout
        ? IGNORE_BREAKPOINT_MAX_WIDTH
        : BREAKPOINT_DESKTOP}px) {
    .row-1 {
      font-size: 21px;
      height: 21px;
    }
    .row-2 {
      font-size: 93px;
      height: 93px;
      padding: 3px 0;
    }
    .row-3 {
      height: 21px;
      font-size: 21px;
    }
  }
  @media (min-width: ${props =>
      props.$isGridLayout
        ? IGNORE_BREAKPOINT_MIN_WIDTH
        : BREAKPOINT_DESKTOP}px) {
    .row-2 {
      font-size: ${props => widthPxFromPercent(props.$width, 12)}px;
    }
  }
  @media print {
    .row-1,
    .row-2,
    .row-3 {
      font-size: 16px;
      .bottomRowItem3 {
        font-size: 16px;
      }
    }

    .row-1 {
      padding-top: 1em;
    }

    .row-2 {
      height: 35px;
      font-size: 24px !important;
    }

    .row-3 {
      padding-bottom: 2em;
    }
  }
`;

export const AnimatedBottomRowItemStyles = animated(BottomRowItemStyles);
